import { connection } from './connection'

export default {
  getSystemNotifications () {
    return connection.get('bo/system-notifications')
  }
}
